import {
    configureStore,
    ThunkAction,
    UnknownAction,
} from '@reduxjs/toolkit'
import recordingSession from './Components/RecordingSessionEditor/redux/reducers';
import rightDrawer from './Components/RightDrawer/rightDrawerSlice';

export const store = configureStore({
    reducer: {
        recordingSession,
        rightDrawer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these field paths in all actions
                ignoredActionPaths: [/.*\.updatedAt/, /.*\.ref/],
                // Ignore these paths in the state
                ignoredPaths: [/recordingSession\..*\.updatedAt/, /recordingSession\..*\.ref/],
            },
        }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    UnknownAction
>
